import axios from 'axios';
import { apiDomain } from '@/config';

import * as types from './types';

const actions = {
  reset: ({ commit }) => {
    commit(types.RESET);
  },
  async fetchJobs({ rootState, commit }, payload) {
    commit(types.FETCH_JOBS_PENDING);
    try {
      const companyId = payload.companyId || rootState.company.profile.company.id;
      const url = `${apiDomain}company/${companyId}/jobs`;
      const response = await axios.get(`${url}?scope=${payload.listType}`);
      commit(types.FETCH_JOBS_FULFILLED, { jobs: response.data.data, listType: payload.listType });
      return true;
    } catch (error) {
      commit(types.FETCH_JOBS_ERROR);
      return Promise.reject(error);
    }
  },
  async fetchJob({ commit }, payload) {
    commit(types.FETCH_JOB_PENDING);
    try {
      const response = await axios.get(`${apiDomain}company/${payload.companyId}/jobs/${payload.jobId}`);
      commit(types.FETCH_JOB_FULFILLED, response);
      return true;
    } catch (error) {
      commit(types.FETCH_JOB_ERROR);
      return Promise.reject(error);
    }
  },
  async storeJob({ commit, dispatch }, payload) {
    commit(types.STORE_JOB_PENDING);
    try {
      const method = payload.form.id ? 'PATCH' : 'POST';
      const jobsUrl = `${apiDomain}company/${payload.companyId}/jobs`;
      const url = payload.form.id ? `${jobsUrl}/${payload.form.id}` : jobsUrl;
      const response = await axios({ url, method, data: payload.form });
      commit(types.STORE_JOB_FULFILLED);
      const successMessage = payload.form.id ? 'alert.updateJobSuccessful' : 'alert.addJobSuccessful';
      dispatch('messages/showMessage', { key: successMessage, color: 'success' }, { root: true });
      return response.data.data;
    } catch (error) {
      commit(types.STORE_JOB_ERROR);
      const errorMessage = payload.form.id ? 'alert.updateJobError' : 'alert.addJobError';
      dispatch('messages/showMessage', { key: errorMessage, color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
  async deleteJob({ commit, dispatch }, payload) {
    commit(types.DELETE_JOB_PENDING);
    try {
      const baseUrl = `${apiDomain}company/${payload.companyId}/jobs/${payload.jobId}`;
      const url = payload.cancellationReasonCode ? `${baseUrl}?cancellation_reason_code=${payload.cancellationReasonCode}` : baseUrl;
      const response = await axios.delete(url);
      dispatch('fetchJobs', { listType: payload.listType });
      commit(types.DELETE_JOB_FULFILLED, response);
      dispatch('messages/showMessage', { key: 'alert.deleteJobSuccessful', color: 'success' }, { root: true });
      return true;
    } catch (error) {
      commit(types.DELETE_JOB_ERROR);
      dispatch('messages/showMessage', { key: 'alert.deleteJobError', color: 'error' }, { root: true });
      return Promise.reject(error);
    }
  },
};

export default actions;
